import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert,
} from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import {
    fetchAttendanceRequest,
    createAttendanceRequest,
    editAttendanceRequest,
} from "../../../api/attendance";
import { fetchEmployeeRequest } from "api/employee";
import { getFullName } from "helpers/functions/employee";

class AttendanceForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resource: {
                date: "",
                timeIn: "",
                breakAmStart: "",
                breakAmEnd: "",
                lunchStart: "",
                lunchEnd: "",
                breakPmStart: "",
                breakPmEnd: "",
                timeOut: "",
                employee: "",
            },
            error: null,
            employee: {}
        };
    }

    componentDidMount() {

        const { instanceId, employeeId } = this.props;

        if (instanceId) {
            this.fetchInstance(instanceId);
        }

        if(employeeId) {
            fetchEmployeeRequest(
                employeeId,
                (result) => this.setState({ employee: result }),
                (error) => this.setState({ error: "There was an error" }),
            );
        }
    }

    fetchInstance = (id) => {
        fetchAttendanceRequest(
            id,
            (result) =>
                this.setState((prevState) => ({
                    resource: {
                        ...prevState.resource,
                        ...result,
                    },
                })),
            (error) => this.setState({ error: "There was an error" }),
        );
    };

    handleFormChange = (e) => {
        const { target } = e;
        const { name, value } = target;

        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [name]: value,
            },
        }));
    };

    onChangeDate = (date, field) => {
        let value = moment(date).format("YYYY-MM-DD");
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [field]: value,
            },
        }));
    };

    save = () => {
        console.log("saving...");
        const {
            date,
            timeIn,
            breakAmStart,
            breakAmEnd,
            lunchStart,
            lunchEnd,
            breakPmStart,
            breakPmEnd,
            timeOut,
        } = this.state.resource;

        const { instanceId } = this.props;

        const isNewRecord = !instanceId;

        let data = {
            employee: this.state.resource.employee
                ? this.state.resource.employee._id
                : this.props.employeeId,
            date,
            timeIn,
            breakAmStart,
            breakAmEnd,
            lunchStart,
            lunchEnd,
            breakPmStart,
            breakPmEnd,
            timeOut,
        };

        if (isNewRecord) {
            createAttendanceRequest(
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(error),
            );
        } else {
            editAttendanceRequest(
                instanceId,
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(error),
            );
        }
    };

    saveSuccess = () => {
        this.setState({ error: null });
        this.props.goBack();
    };

    saveFailure = (error) => {
        this.setState({
            error: error.message || "There was an error saving Attendance.",
        });
    };

    render() {
        const {
            timeIn,
            breakAmStart,
            breakAmEnd,
            lunchStart,
            lunchEnd,
            breakPmStart,
            breakPmEnd,
            timeOut,
        } = this.state.resource;

        const date = this.state.resource.date
            ? moment(this.state.resource.date, "YYYY-MM-DD").toDate()
            : "";

        const { error, employee={} } = this.state;

        const { instanceId } = this.props;

        const isNewRecord = !instanceId;

        return (
            <Row>
                <Col md={12}>
                    <Card
                        title={isNewRecord ? "New entry" : "Edit entry"}
                        content={
                            <form>
                                <Button
                                    className="card-top-btn btn-primary"
                                    onClick={() => this.props.goBack()}
                                >
                                    Back to List
                                </Button>
                                <FormGroup>
                                    <ControlLabel>Employee</ControlLabel>
                                    <FormControl
                                        readOnly
                                        componentClass="select"
                                        name="employee"
                                        value={employee._id}
                                    >
                                        <option
                                            value={employee._id}
                                        >
                                            {getFullName(employee)}
                                        </option>
                                    </FormControl>
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Date</ControlLabel>
                                    <DatePicker
                                        selected={date}
                                        onChange={(date) =>
                                            this.onChangeDate(date, "date")
                                        }
                                        dateFormat="MM/dd/yyyy"
                                        className="dateInput"
                                        dropdownMode="select"
                                        showYearDropdown
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Time In</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, excluding seconds
                                        (eg: 13:55)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="timeIn"
                                        value={timeIn}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Break AM Start</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, excluding seconds
                                        (eg: 13:55)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="breakAmStart"
                                        value={breakAmStart}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Break AM End</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, excluding seconds
                                        (eg: 13:55)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="breakAmEnd"
                                        value={breakAmEnd}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Lunch Start</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, excluding seconds
                                        (eg: 13:55)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="lunchStart"
                                        value={lunchStart}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Lunch End</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, excluding seconds
                                        (eg: 13:55)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="lunchEnd"
                                        value={lunchEnd}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Break PM Start</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, excluding seconds
                                        (eg: 13:55)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="breakPmStart"
                                        value={breakPmStart}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Break PM End</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, excluding seconds
                                        (eg: 13:55)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="breakPmEnd"
                                        value={breakPmEnd}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Time Out</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, excluding seconds
                                        (eg: 13:55)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="timeOut"
                                        value={timeOut}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                {error && (
                                    <Alert bsStyle="danger">{error}</Alert>
                                )}
                                <Button
                                    bsStyle="primary"
                                    pullRight
                                    fill
                                    onClick={this.save}
                                >
                                    {isNewRecord ? "Create" : "Save changes"}
                                </Button>
                                <div className="clearfix" />
                            </form>
                        }
                    />
                </Col>
            </Row>
        );
    }
}

export default AttendanceForm;
